import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getInsuranceTypeCategories = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetInsuranceType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getInsuranceTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.GetInsuranceType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertInsuranceType = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.GetInsuranceType,
    input
  );
  return data;
};

const updateInsuranceType = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.GetInsuranceType,
    input
  );
  return data;
};

const deleteInsuranceType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.GetInsuranceType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useInsuranceTypeCategoriesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetInsuranceType],
    queryFn: () => getInsuranceTypeCategories(input),
    refetchOnWindowFocus: false,
  });
};

export const useGetInsuranceTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetInsuranceType],
    queryFn: () => getInsuranceTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertInsuranceTypeMutation = () => {
  return useMutation({
    mutationFn: insertInsuranceType,
  });
};

export const useUpdateInsuranceTypeMutation = () => {
  return useMutation({
    mutationFn: updateInsuranceType,
  });
};

export const useDeleteInsuranceTypeMutation = () => {
  return useMutation({
    mutationFn: deleteInsuranceType,
  });
};
